import { createContext } from "react";
import type { SelectedEntitiesContextType } from "../SelectedEntitiesProvider.types";

const SelectedEntitiesContext = createContext<SelectedEntitiesContextType | undefined>(undefined);
SelectedEntitiesContext.displayName = "SelectedEntitiesContext";

export default SelectedEntitiesContext;
